export class PartsFluidsItem {
    equipment!: string
    equipmentDescription?: string
    source!: string
    category!: string
    subCategory?: string
    itemLabel!: string
    itemValue!: string
    itemKey!: string
    quantity?: number
    um?: string
    details?: string
    notes?: string
    recordId?: string
    suggestedVendor?: string
    unitCost?: number
}

export class PartsFluidsCatalogItem {
    itemKey!: string
    itemValue!: string
    categories?: string
    sources?: string
    description?: string
    equipmentCount!: number
    recordCount!: number
}

export function normalizePartsFluidsItemKey(value: string | null | undefined): string {
    if (!value) return ''
    return value.trim().toUpperCase().replace(/\s+/g, ' ')
}
